import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import userReducer from './redux/reducers/useReducer';  



const rootReducer = combineReducers({
  user: userReducer,
 
});

const store = createStore(rootReducer);

export default store;
